import RangeSelector from './src/main';

/* istanbul ignore next */
RangeSelector.install = function(Vue) {
  Vue.component(RangeSelector.name, RangeSelector);
};

export default RangeSelector;
